import { useTranslation } from "react-i18next";
import slideImage from "@/assets/onboarding-slide-2-v4.webp";

export function OnboardingSlideOne() {
  const { t } = useTranslation();

  return (
    <div className="h-full flex flex-col items-center justify-center px-6 pb-32 relative overflow-hidden">
      {/* Hero image - fixed dimensions to prevent CLS */}
      <img
        src={slideImage}
        alt="Balance visualization"
        width={246}
        height={328}
        className="w-[246px] h-auto max-w-full translate-x-[6px]"
        loading="lazy"
      />

      {/* Text content with glass card - minimal gap */}
      <div 
        className="text-center relative z-10 px-6 py-5 rounded-2xl w-full max-w-xs mt-4"
        style={{
          background: 'linear-gradient(135deg, hsl(var(--card) / 0.6), hsl(var(--card) / 0.3))',
          backdropFilter: 'blur(20px) saturate(180%)',
          border: '1px solid hsl(var(--border) / 0.3)',
        }}
      >
        <h1 className="text-2xl font-bold text-foreground mb-3 leading-snug">
          {t("onboarding.oneNumber.title")}
        </h1>
        <p className="text-muted-foreground text-base leading-relaxed">
          {t("onboarding.oneNumber.subtitle")}
        </p>
      </div>
    </div>
  );
}
